import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { fetchData } from '../../../helpers/methods';

import SpinnerContainer from '../../../component-library/spinner-container';
import SearchCard from '../../../component-library/search-card';

const Favourites = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);

	const getData = () => {
		setLoading(true);
		fetchData({
			uri: '/api/web/my/store',
			method: 'GET',
		})
			.then(res => {
				const newData = res.body.favouritesSummary;
				setData(newData);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const handleCardClick = id => {
		navigate(`../details/${id}`, { state: { from: 'favorites' } });
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div>
			<h2>My Favorites</h2>
			{loading && (
				<SpinnerContainer />
			)}
			{!loading && (
				data?.length > 0 ? (
					<div className="search__results-grid">
						{data.map((item, index) => (
							<SearchCard
                                // eslint-disable-next-line react/no-array-index-key
								key={index}
								id={item.id}
								title={item.name}
								interfaceType={item.interfaceType?.name}
								version={item.version}
								description={item.description}
								state={item.state}
								division={item.division}
								favourite={item.userFavourite}
								subscribed={item.userWatched}
								objectType={item.objectType}
								handleCardClick={id => handleCardClick(id)}
							/>
						))}
					</div>
				) : (
					<p>
						You currently have no favorites to display,
						add some from the search or details screen.
					</p>
				))}
		</div>
	);
};

export default Favourites;
